import Link from 'next/link'
import React from 'react'
import { withI18n } from '~/hocs'
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Row,
  Spinner,
} from 'react-bootstrap'
import {
  assetURL,
  formatDisplayTime,
  getVideoType,
  placeholderSrc,
  kFormatter,
  buildName,
  getAvatar,
} from '~/utils'
import { routes } from '~/router'

const VideoDetail = ({ t, video, lng }) => {
  return (
    <Col xs={12} md={6} lg={8} xl={8}>
      <h3 className="ac-heading-6 ac-mb-2 font-weight-bold">
        この動画について
      </h3>
      <Row>
        <Col md={7} lg={8}>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">タイトル </span>
            <span className="ml-2">{video.title}</span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">動画のID</span>
            <span className="ml-2">{video.id}</span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">動画の長さ</span>
            <span className="ml-2">{video.duration}</span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">フレームレート</span>
            <span className="ml-2">{video.fps || 'N/A'}fps</span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">アスペクト比</span>
            <span className="ml-2">16:9</span>
          </div>
        </Col>
        <Col md={5} lg={4}>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">作者</span>
            <span className="ml-2">
              {(video.user?.nickname ||
                video.user?.email) && (
                <>
                  <Link
                    href={{
                      pathname: routes.user.username.href,
                      query: { id: video.user.id },
                    }}
                    locale={lng}
                  >
                    <a className="text-blue hover hover-underline">
                      {buildName(video.user, lng)}
                    </a>
                  </Link>
                  {lng == 'ja' && 'さん'}
                </>
              )}
            </span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">ダウンロード</span>
            <span className="ml-2">{kFormatter(video.download_count)} 回</span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">音声</span>
            <span className="ml-2">
              {video.has_audio ? t('have') : t('none')}
            </span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">コーデック</span>
            <span className="ml-2">{video.codec}</span>
          </div>
          <div className="border-bottom ac-pb-1 ac-mb-1">
            <span className="font-weight-bold">タイプ</span>
            <span className="ml-2">{getVideoType(video.mime_type)}</span>
          </div>
        </Col>
        <div className="ml-2">
          <img src="https://jp.static.photo-ac.com/assets/img/profile/02.png" height="22" width="77" alt="safety" className="ac-mr-2 ac-mb-1 lazy loaded" data-ll-status="loaded"></img>
          <span className="">
            この動画素材の投稿者
            <Link
              href={{
                pathname: routes.user.username.href,
                query: { id: video.user?.id },
              }}
              locale={lng}
            >
              <a className="text-blue hover hover-underline">
                {buildName(video.user, lng)}
              </a>
            </Link>
            さんは、本人確認が済んでいるクリエイターです。
          </span>
        </div>
      </Row>
    </Col>
  )
}

export default withI18n(VideoDetail)
